(() => {
  /**
   * @param {HTMLElement | Document} root
   */
  function init(root) {
    const sections = root.querySelectorAll('.mt-shot-video');

    sections.forEach((section) => {
      const video = section.querySelector('.mt-shot-video-player');
      const replayBtn = section.querySelector('.mt-shot-video-replay');

      if (!(video instanceof HTMLVideoElement) || !(replayBtn instanceof HTMLButtonElement)) return;
      if (video.dataset.mtShotVideoInit === 'true') return;
      video.dataset.mtShotVideoInit = 'true';

      const hideReplay = () => replayBtn.classList.remove('is-visible');
      const showReplay = () => replayBtn.classList.add('is-visible');

      // Make autoplay as robust as possible across Safari/iOS policies.
      video.autoplay = true;
      video.loop = true;
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('autoplay', '');
      video.setAttribute('loop', '');
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');

      /** @type {boolean} */
      let hasPlayed = false;

      const tryAutoplay = () => {
        if (hasPlayed) return;
        if (document.visibilityState === 'hidden') return;

        // If preload is "none", ensure we start fetching when it's time to play.
        if (video.preload === 'none' && video.readyState < 2) {
          try {
            video.load();
          } catch (e) {
            // ignore
          }
        }

        const playPromise = video.play();
        if (playPromise && typeof playPromise.then === 'function') {
          playPromise
            .then(() => {
              hasPlayed = true;
            })
            .catch(() => {
              // Autoplay can be blocked; we'll retry on canplay/visibility/user gesture.
            });
        }
      };

      hideReplay();

      // Retry when the video is actually ready.
      video.addEventListener('canplay', tryAutoplay, { once: true });

      // Retry when coming back to the tab.
      document.addEventListener('visibilitychange', tryAutoplay);

      // Only attempt autoplay when in view (helps prevent some browsers from blocking).
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(
          (entries) => {
            if (entries.some((e) => e.isIntersecting)) {
              tryAutoplay();
              io.disconnect();
            }
          },
          { threshold: 0.2 }
        );
        io.observe(video);
      } else {
        tryAutoplay();
      }

      // If autoplay is blocked, a user gesture should allow play.
      const unlock = () => {
        tryAutoplay();
        window.removeEventListener('pointerdown', unlock, true);
        window.removeEventListener('touchstart', unlock, true);
        window.removeEventListener('click', unlock, true);
      };
      window.addEventListener('pointerdown', unlock, true);
      window.addEventListener('touchstart', unlock, true);
      window.addEventListener('click', unlock, true);

      video.addEventListener('play', () => {
        hasPlayed = true;
        hideReplay();
      });
      // Looping video should not show replay UI.
      video.addEventListener('ended', () => {
        if (video.loop) return;
        showReplay();
      });

      replayBtn.addEventListener('click', () => {
        hasPlayed = false;
        video.currentTime = 0;
        hideReplay();
        tryAutoplay();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => init(document));

  // Shopify Theme Editor: sections can be dynamically re-rendered without full page reload.
  document.addEventListener('shopify:section:load', (event) => {
    if (event?.target instanceof HTMLElement) init(event.target);
  });
})();
